import { Injectable } from '@angular/core';
import { ListingExportConfig } from '@portal/shared/types/listing.types';
import { ExportRow } from '@portal/shared/types/export.types';
import { TableData } from '@portal/shared/types/api-response.types';
import { TwoWayRequestItemListResponseDto } from '../services/request-processing.types';
import { mapRequestProcessingToExport } from './request-processing-listing.export';

@Injectable()
export class RequestProcessingListingExportConfigService implements ListingExportConfig {
  readonly fileName = 'Export-2-Way_RequestProcessing';

  readonly mapData = (data: TableData<TwoWayRequestItemListResponseDto>): ExportRow[] =>
    data.data.map(mapRequestProcessingToExport);
}
